import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrainStation = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00754a",
			height: 24,
			rx: 12,
			width: 24
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#fff",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m6.375 11.4375h11.25",
					strokeLinecap: "square"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m6.375 7.5h11.25",
					strokeLinecap: "square"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m9.75 17.625-1.6875 1.6875",
					strokeLinecap: "square"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m14.25 17.625 1.6875 1.6875",
					strokeLinecap: "square"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m15.9375 4.6875h-7.875c-.93198 0-1.6875.75552-1.6875 1.6875v9c0 .932.75552 1.6875 1.6875 1.6875h7.875c.932 0 1.6875-.7555 1.6875-1.6875v-9c0-.93198-.7555-1.6875-1.6875-1.6875z",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m12 7.5v3.9375",
					strokeLinecap: "square"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m8.90625 15.375c.46599 0 .84375-.3778.84375-.8438 0-.4659-.37776-.8437-.84375-.8437s-.84375.3778-.84375.8437c0 .466.37776.8438.84375.8438z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m15.0938 15.375c.4659 0 .8437-.3778.8437-.8438 0-.4659-.3778-.8437-.8437-.8437-.466 0-.8438.3778-.8438.8437 0 .466.3778.8438.8438.8438z",
			fill: "#fff"
		})
	]
});
export default SvgTrainStation;
